import dice from "../src/images/dice-game.png";
import fruit from "../src/images/fruit.png";
import eCommerceImage from "../src/images/eCommerce.png";
import rdcs from "../src/images/RDCS.png";
import intellica from "../src/images/intellica.png";
import eunoia from "../src/images/Eunoia.png";
import geopayment from "../src/images/Geopayment.png";
import chatbot from "../src/images/chatbotwidget.png";

// new images
import alex from "../src/images/ALEX.png";
import careerPilot from "../src/images/CareerPilot.png";
import voiceBlast from "../src/images/VoiceBlast.png";
import eventTrail from "../src/images/EventTrail.png";
import globalFoodMap from "../src/images/globalfoodmap.png";
import fsla from "../src/images/FSLA.png";
import theRequestPoster from "../src/images/The Request Thubmnail poster.png";
import stockpileIntelHub from "../src/images/StockpileIntelHub.png";
import theLastImport from "../src/images/TheLastImport.png";

const portfolio = [
  {
    image: theLastImport,
    title: "The Last Import — A Civilisation Simulation",
    descriptions: [
      "Interactive Storytelling, Systems Thinking, Game Design, AI-Assisted Web Development.",
      "Design statement: How might a playful simulation make invisible dependencies—and the consequences of our decisions—easier to understand?",
      "The Last Import is a fictional civilisation simulation about the things we forgot to grow. Players manage food, water, energy and healthcare as disrupted imports turn everyday assumptions into urgent committee business.",
      "Choose a society, adjust its resources and enact interventions. Deterministic calculations shape the indicators and narrative endings, while illustrated characters reveal the human consequences behind the dashboard.",
      "Built using ChatGPT Sites, the project explores its capabilities for web development and UI implementation: translating a visual concept into a playable experience, connecting simulation logic to interactive controls, refining responsive layouts, and testing quick PDF export flows.",
      "A practical experiment in how far conversational development can take a prototype—from an illustrated idea to a working game.",
    ],
    link: "https://the-last-import-game.neonrook37.chatgpt.site/",
    buttons: [
      {
        text: "The Last Import",
        link: "https://the-last-import-game.neonrook37.chatgpt.site/",
      },
    ],
  },
  {
    youtubeId: "GJThlE9xVqM",
    poster: theRequestPoster,
    title: "The Request — AI Short Film Experiment",
    descriptions: [
      "Generative Video, AI Filmmaking, Narrative Design, Creative Direction.",
      "Design statement: How might humour and cinematic storytelling make a sensitive organisational tension easier to talk about?",
      "The Request is a short AI-generated film created as an experiment in generative video models, character consistency, voice, cinematic pacing, and multi-shot storytelling.",
      "An ordinary request — “Can we add an Export to Excel button?” — becomes a Korean melodrama and, somehow, a wuxia epic.",
      "The joke is familiar: Business sees a button. IT sees infrastructure, security, data, procurement, operations, vendors and consequences. Nobody is the villain. Complexity is.",
      "The melodrama is deliberate. Humour takes some of the sting out of the old “us versus them” tension and gets to the real point: when delivery works well, complexity disappears. Sometimes the work disappears with it.",
      "The project also served as a practical exploration of AI video production workflows: recurring characters, image-to-video continuity, voice consistency, cinematic transitions, title treatments, and assembling independently generated shots into a coherent film.",
    ],
    buttons: [
      {
        text: "The Request",
        link: "https://youtu.be/GJThlE9xVqM",
      },
    ],
  },
  {
    image: stockpileIntelHub,
    title: "National Food Stockpile Intelligence Platform (NFSIP)",
    descriptions: [
      "Food Security Intelligence, National Resilience Planning, Inventory Analytics, UX/UI, Fullstack Prototype.",
      "Design statement: How might we give governments a real-time and strategic view of national food resilience across fragmented public and private supply chains?",
      "A mission-critical command dashboard for national food security operations, combining real-time stockpile monitoring, risk intelligence, scenario modeling, and ERP integration across the national supply chain.",
      "The platform aggregates inventory data from strategic reserves, importers, distributors, warehouses, retailers, and inbound pipelines to calculate coverage days, classify stock tiers, monitor risk signals, and support crisis decision-making.",
    ],
    listItems: [
      "National coverage view across core commodities, registered entities, stock records, and 30-day supply trends.",
      "Inventory intelligence organized by stock tiers such as Strategic Reserve, Regulated Buffer, Commercial Warehouse, Retail, and Inbound Pipeline.",
      "Risk radar with severity scoring and mitigation guidance across operational, supply, expiry, threshold, and disruption signals.",
      "Programme engine for reserve calculation rules, HS code classifications, compliance thresholds, reporting obligations, and audit-ready governance.",
    ],
    link: "https://stockpile-intel-hub.replit.app/",
    buttons: [
      {
        text: "NFSIP",
        link: "https://stockpile-intel-hub.replit.app/",
      },
    ],
  },
  {
    image: fsla,
    title: "Food Safety Layout Auditor (FSLA)",
    descriptions: [
      "Food Safety Compliance, AI Vision Analytics, Enterprise Integration, UX/UI, Fullstack Development.",
      "Design statement: How might we empower food safety inspectors and restaurant operators to instantly identify cross-contamination risks in commercial kitchens using AI-driven spatial analysis?",
      "Built in React, TypeScript, and Node.js with an Express API backend, integrated with Google GenAI (Gemini Vision) and Salesforce (Client Credentials). Deployed on Google Cloud Run with Firebase Auth and Firestore for real-time state management and historical audit tracking.",
      "An AI-powered food safety intelligence platform fusing computer vision, spatial risk modeling, and enterprise data synchronization into a unified auditing interface.",
    ],
    listItems: [
      "Automated kitchen zone detection using multimodal AI to identify raw preparation, ready-to-eat, and wash areas directly from floor plan images or photographs.",
      "Algorithmic spatial risk engine calculating Euclidean distances between identified zones and modeling microbial transfer probabilities to surface cross-contamination vulnerabilities.",
      "Automated compliance scoring and violation generation, categorizing risks by severity (Critical, High, Medium, Low) to prioritize remediation efforts.",
      "Seamless enterprise synchronization with Salesforce via secure Client Credentials flow, pushing audit telemetry and safety scores directly into custom CRM objects for centralized compliance monitoring.",
    ],
    link: "https://food-safety-layout-auditor-fsla-624721050843.us-west1.run.app/",
    buttons: [
      {
        text: "Food Safety Layout Auditor",
        link: "https://food-safety-layout-auditor-fsla-624721050843.us-west1.run.app/",
      },
    ],
  },
  {
    image: globalFoodMap,
    title: "Global Food & Maritime Compliance Tracker (GF-MCT)",
    descriptions: [
      "Food Security Intelligence, Maritime Domain Awareness, Geospatial Analytics, UX/UI, Fullstack Development.",
      "Design statement: How might we give Singapore's food security planners real-time visibility into the full breadth of supply chains that the nation depends on for over 90% of its food?",
      "Built in React, TypeScript, and Node.js with an Express API backend, integrated with AISStream.io (live AIS WebSocket), MPA OCEANS-X, UN Comtrade, and USDA PSD APIs. Deployed on Replit Autoscale with PostgreSQL for cross-instance coordination.",
      "A geospatial food security intelligence platform fusing live vessel tracking, port arrival declarations, global commodity trade data, and supply disruption signals into a unified command-centre interface.",
    ],
    listItems: [
      "Live AIS vessel tracking across the Singapore Strait with automated geofence alerting and multi-signal cargo inference.",
      "Global food trade visualisation by commodity, surfacing supply concentration risks and alternative supplier exposure.",
      "Disruption intelligence feed scored by severity, enriched with AI risk assessments across key chokepoints and commodities.",
      "Unified analytical layer designed to complement official MPA and SFA systems for supply chain monitoring and policy support.",
    ],
    link: "https://global-food-map.replit.app/",
    buttons: [
      {
        text: "Global Food Map",
        link: "https://global-food-map.replit.app/",
      },
    ],
  },
  {
    image: alex,
    title: "Learning Management System",
    descriptions: [
      "UX/UI, Frontend Prototype",
      "A front-end prototype showcasing an AI-integrated engine that enables interest-driven, self-paced learning experiences.",
    ],
    link: "https://alex-ba.vercel.app/",
    buttons: [
      {
        text: "Learning Management System",
        link: "https://alex-ba.vercel.app/",
      },
    ],
  },
  {
    image: careerPilot,
    title: "Career Advisory Web Platform",
    descriptions: [
      "UX/UI, Fullstack Development",
      "An AI-powered platform to guide job seekers through personalized career exploration, offering tailored recommendations and actionable insights through Mock Interviews etc.",
    ],
    link: "https://career-grit-amalinazafirahh.replit.app/",
    buttons: [
      {
        text: "Career Advisory",
        link: "https://career-grit-amalinazafirahh.replit.app/",
      },
    ],
  },
  {
    image: voiceBlast,
    title: "Public Announcement System",
    descriptions: [
      "UX/UI, Prototype",
      "A Text-to-Speech platform for automated AI-generated announcements and broadcasting.",
    ],
    link: "https://voice-blast-amalinazafirahh.replit.app/",
    buttons: [
      {
        text: "Public Announcement",
        link: "https://voice-blast-amalinazafirahh.replit.app/",
      },
    ],
  },
  {
    image: eventTrail,
    title: "Event Trail Challenge",
    descriptions: [
      "UX/UI, Mobile App Prototype",
      "A geo-location event app with an interactive trail map, checkpoint pins, and social sharing to drive engagement and event visibility.",
    ],
    link: "https://lbtl-amalinazafirahh.replit.app/",
    buttons: [
      {
        text: "Event Trail",
        link: "https://lbtl-amalinazafirahh.replit.app/",
      },
    ],
  },
  {
    image: geopayment,
    title: "Geopayment",
    descriptions: [
      "UX/UI, Fullstack Development",
      "Backend built in Python, Django and deployed on Google Cloud Platform. Frontend on ReactJS with Stripe, Google APIs and deployed on Firebase.",
      "A geofencing payment system designed for use at event spaces, carparks, gyms etc.",
    ],
    link: "https://rfid-project-424315.web.app/",
    buttons: [
      {
        text: "Geopayment",
        link: "https://rfid-project-424315.web.app/",
      },
    ],
  },
  {
    image: chatbot,
    title: "Chatbot Widget",
    descriptions: [
      "UX/UI, Fullstack Development",
      "Backend built in JavaScript with integrations to GPT-4-Turbo and ElevenLabs' custom voice Text-to-Speech, Microsoft Azure Cosmos DB and deployed on Mircososft Azure App Services. Frontend on ReactJS, Tailwind CSS and deployed on Microsoft Azure Static Web Apps.",
      "This project consists of an admin portal and a chatbot widget. The admin portal allows users to upload their information and generate a chatbot widget, which can be integrated into any existing ReactJS project. The chatbot widget can be used to interact with users and respond to their queries based on the uploaded information. The chatbot on this website is using this widget (my custom AI voice created on ElevenLabs).",
    ],
    link: "https://happy-flower-0c7eb4a00.5.azurestaticapps.net/",
    buttons: [
      {
        text: "Chatbot Widget",
        link: "https://happy-flower-0c7eb4a00.5.azurestaticapps.net/",
      },
    ],
  },
  {
    image: dice,
    title: "Dice Game",
    descriptions: [
      "UX/UI, Frontend Development",
      "Built in HTML, CSS and JavaScript.",
      "Inspired by the DIY children's floor dice game.",
    ],
    link: "https://amalina-hashim.github.io/dice-game/",
    buttons: [
      {
        text: "Dice Game",
        link: "https://amalina-hashim.github.io/dice-game/",
      },
    ],
  },
  {
    image: fruit,
    title: "Fruit Journal",
    descriptions: [
      "UX/UI, Fullstack Development.",
      "Built in ReactJS, with integrations to Google Maps, Google Vision AI, Airtable, Cloudinary and Vercel.",
      "This is a mobile camera image detection fruit journal."
    ],
    link: "https://fruit-journal-clarifai-488v.vercel.app",
    buttons: [
      {
        text: "Fruit Journal",
        link: "https://fruit-journal-clarifai-488v.vercel.app",
      },
    ],
  },
  {
    image: eCommerceImage,
    title: "An eCommerce site",
    descriptions: [
      "UX/UI, Fullstack Development.",
      "Built in ReactJS, Express, NodeJS & MongoDB integrated to Stripe and custom APIs. Deployed on Render and Vercel.",
      "An eCommerce platform, with supporting backend APIs for user, products, cart, favorites, payment and orders management. Check out the eCommerce Site and View Orders dashboard below.",
    ],
    link: "https://webstore-rosy.vercel.app",
    buttons: [
      {
        text: "eCommerce Site",
        link: "https://webstore-rosy.vercel.app",
      },
      {
        text: "View Orders",
        link: "https://view-orders.vercel.app",
      },
    ],
  },
  {
    image: rdcs,
    title: "Receipt Data Capturing System",
    descriptions: [
      "Product Management, Product Ownership, Project Management.",
      "Design statement: how might we scale the impact of the Eat Drink Shop Healthy campaign and increase Healthier purchases among Singaporeans.",
      "By enabling a digital rewards system through the capture of purchase transactions in real time, the Receipt Data Capturing System was strategically designed to enable the following key features:",
    ],
    source: {
      text: "https://www.healthhub.sg/programmes/nutrition-hub/eat-drink-shop-healthy-challenge",
      link: "https://www.healthhub.sg/programmes/nutrition-hub/eat-drink-shop-healthy-challenge",
    },
    listItems: [
      "Quick insights to purchasing patterns.",
      "Ease of integrations with Partner Point-of-sales systems.",
      "Ease of deployment and maintenance.",
      "Usable data across multiple internal platforms for Business Intelligence and Policy Development.",
    ],
    buttons: [
      {
        text: "EDSH",
        link: "https://www.healthhub.sg/programmes/nutrition-hub/eat-drink-shop-healthy-challenge",
      },
    ],
  },
  {
    image: intellica,
    title: "Waste Monitoring System",
    descriptions: [
      "UX & Field Research, Design, Product Management",
      "Reducing Adoption Barriers to Food Waste Tracking Solutions in Commercial Kitchens. A Research Thesis - SUTD MEng Innovation by Design.",
      "Design statement: How might we reduce the barriers that exist within the F&B industry that discourages operators from adopting waste tracking solutions in their operations.",
    ],
    link: "https://www.researchgate.net/publication/380631617_Reducing_Adoption_Barriers_to_Food_Waste_Tracking_Solutions_in_Commercial_Kitchens#fullTextFileContent",
    buttons: [
      {
        text: "Research Thesis",
        link: "https://www.researchgate.net/publication/380631617_Reducing_Adoption_Barriers_to_Food_Waste_Tracking_Solutions_in_Commercial_Kitchens#fullTextFileContent",
      },
    ],
  },
  {
    image: eunoia,
    title: "F&B eCommerce Platform",
    descriptions: [
      "Product Management",
      "Unifying a fragmented tech ecosystem",
      "Design statement: how might we simplify the management of online orders, customers, digital payments and delivery fulfilment with the objective of increasing revenue and customer engagement effectively.",
      "The solution is a platform that supports mobile applications, responsive web ordering sites, a delivery-rider app, and a backend admin system with integrations to fulfillment channels, and riders, integrating seamlessly with payment gateways, e-wallets, CRM, POS, and other utility services.",
    ],
    link: "https://www.eunoia.asia/platform",
    buttons: [
      {
        text: "Eunoia Platform",
        link: "https://www.eunoia.asia/platform",
      },
    ],
  },
];

const db = { portfolio };

export default db;
